




































































































































































































































































































































































































































import { importLoop } from "@/utils/import";
import commonUploader from "@/components/commonUploader.vue";
import { Vue, Component } from "vue-property-decorator";
import { smsAreaCodeListApi } from "@/api/signIn";
import {
  sourceTypeSelectListApi,
  getStudentAppearListApi,
} from "@/api/storeManagement";
import { getLatentExcelApi } from "@/api/studentManage";
import { getSeleSubjectsList } from "@/api/globalSearch";
import {
  createImportTaskApi,
  importErrorVerifyInter,
  importErrorVerifyApi,
  importErrorCreateApi,
} from "@/api/taskCenter";
@Component({
  name: "uploadLatentTableDialog",
  components: {
    commonUploader,
  },
})
export default class extends Vue {
  dialogVisible: boolean = false;
  currentStep: number = 1;
  sampleLink: string = "";
  selectFileName: string = "";
  uploadFileKey: string = "";
  visibilityDialog: boolean = false;
  success_total: number = 0;
  abnormal_total: number = 0;
  mobile_repeat_total: number = 0;
  studentTotal: number = 0;
  tableData: any = [];
  uploadResult = {
    success: 0,
    total: 0,
    fail: 0,
    link: "",
  };
  areaCodeList: any = [];
  studentAppearList: any[] = [];
  staffList: any[] = [];
  marketStaffList: any[] = [];
  subjectList: any[] = [];
  tableTaskId: number = 0;
  handleCancel() {
    this.currentStep = 1;
    this.visibilityDialog = false;
  }
  handleConfirm() {
    let errorNum = 0;
    this.tableData.map((item: any) => {
      if (item.error_background === "error_background_color") {
        errorNum++;
      }
    });
    if (errorNum > 0) {
      this.$message({
        type: "error",
        message: "还存在" + errorNum + "条异常数据，请先处理",
      });
      return;
    }
    let tableList: importErrorVerifyInter[] = [];
    this.tableData.map((val: any) => {
      tableList.push({
        student_name: val.student_name,
        area_code: val.area_code,
        mobile: val.mobile,
        wechat: val.wechat,
        market_staff: val.market_staff,
        appear: val.appear,
        source: val.source,
        sex: val.sex,
        birthday: val.birthday,
        follow_staff: val.follow_staff,
        custody_staff: val.custody_staff,
        spare_area_code: val.spare_area_code,
        spare_mobile: val.spare_mobile,
        address: val.address,
        school: val.school,
        subject: val.subject,
        is_potential: val.is_potential,
        remark: val.remark,
      });
    });
    importErrorCreateApi({
      task_id: this.tableTaskId,
      list: tableList,
    }).then((res: any) => {
      if (res.error_code === 0) {
        // 不等于null证明还有错误
        if (res.data !== null) {
          const _t = this;
          let newArr: any = [];
          _t.tableData.map((item: any, index: number) => {
            for (let key in res.data) {
              // 匹配
              if (index === Number(key)) {
                item.error_message = res.data[key];
                item.error_background = "error_background_color";
                newArr.push(item);
              }
            }
          });
          _t.tableData = newArr;
          return;
        }
        this.$message({
          type: "success",
          message: `成功导入${this.studentTotal}条数据`,
        });
        this.visibilityDialog = false;
        this.dialogVisible = false;
        this.$emit("change");
      }
    });
  }
  tableRowClassName(row: any) {
    return row.row.error_background;
  }
  // 检查这一行有没有异常
  checkRow(val: any) {
    let option: importErrorVerifyInter = {
      student_name: val.student_name,
      area_code: val.area_code,
      mobile: val.mobile,
      wechat: val.wechat,
      market_staff: val.market_staff,
      appear: val.appear,
      source: val.source,
      sex: val.sex,
      birthday: val.birthday,
      follow_staff: val.follow_staff,
      custody_staff: val.custody_staff,
      spare_area_code: val.spare_area_code,
      spare_mobile: val.spare_mobile,
      address: val.address,
      school: val.school,
      subject: val.subject,
      is_potential: val.is_potential,
      remark: val.remark,
    };
    importErrorVerifyApi(option).then((res: any) => {
      if (res.error_code === 0) {
        if (res.data.verify && res.data.error_type === 0) {
          // 校验完全通过
          val.error_background = "success_background_color";
          val.error_message = "-";
        } else if (res.data.verify && res.data.error_type === 2) {
          // 手机号码已存在
          val.error_background = "success_background_color";
          val.error_message = res.data.message;
        } else {
          // 校验不通过
          this.tableData.map((item: any) => {
            if (item.id === val.id) {
              item.error_message = res.data.message;
              item.error_background = "error_background_color";
            }
          });
        }
      }
    });
  }
  handleDelete(val: any) {
    for (let i = 0; i < this.tableData.length; i++) {
      if (this.tableData[i].id === val.id) {
        this.tableData.splice(i, 1);
        break;
      }
    }
  }
  openDialog() {
    if (!this.sampleLink) {
      getLatentExcelApi().then((res: any) => {
        this.sampleLink = res.data.excel_url;
      });
    }
    this.dialogVisible = true;
    this.currentStep = 1;
    this.clearDeleteSelect();
    smsAreaCodeListApi().then((res: any) => {
      if (res.error_code === 0) {
        res.data.ncn_list.unshift(...res.data.cn_list);
        res.data.ncn_list.map((item: any) => {
          item.completeCodeName = item.name + "+" + item.code;
        });
        this.areaCodeList = res.data.ncn_list;
      }
    });
    getSeleSubjectsList({
      page: 1,
      page_size: 500,
      status: 1,
    }).then((res: any) => {
      this.subjectList = res.data.list;
    });
    getStudentAppearListApi({
      page: 1,
      page_size: 500,
      status: 1,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.studentAppearList = res.data.list;
      }
    });
  }
  handleSearchSource(row: any) {
    if (!row.appear) {
      return false;
    }
    let target = this.studentAppearList.find((a) => {
      return a.name === row.appear;
    });
    if (target) {
      sourceTypeSelectListApi({ appear_id: target.id, status: 1 }).then(
        (result: any) => {
          row.sourceChannelList = result.data.list;
        }
      );
    }
  }
  handleClose() {
    this.dialogVisible = false;
  }
  handleUpload(data: any) {
    this.selectFileName = data.file_name;
    this.uploadFileKey = data.file_key;
  }
  clearDeleteSelect() {
    this.selectFileName = "";
    this.uploadFileKey = "";
  }
  handleImport() {
    if (!this.selectFileName || !this.uploadFileKey) {
      this.$message({
        type: "warning",
        message: "请先选择文件",
      });
      return false;
    }
    createImportTaskApi({
      type: 1,
      original_file_name: this.selectFileName.split(".")[0],
      file_path: this.uploadFileKey,
    }).then((res: any) => {
      if (res.error_code === 21001001) {
        this.$message({
          type: "error",
          message: res.message,
        });
      } else {
        this.currentStep = 2;
        this.tableTaskId = res.data.task_id;
        importLoop(res.data.task_id)
          .then((tableRes: any) => {
            const data = tableRes.data;
            this.success_total = data.success_total;
            this.abnormal_total = data.abnormal_total;
            this.mobile_repeat_total = data.mobile_repeat_total;
            this.studentTotal =
              data.success_total +
              data.abnormal_total +
              data.mobile_repeat_total;
            if (data.list.length > 0) {
              this.currentStep = 3;
              this.visibilityDialog = true;
              let num = 1;
              data.list.map((item: any) => {
                item.sourceChannelList = [
                  {
                    source_id: item.source,
                    name: item.source,
                  },
                ]; // 各自保存自己的来源渠道
                item.sort = num++;
                item.student_name_flag = false;
                item.area_code_flag = false;
                item.mobile_flag = false;
                item.wechat_flag = false;
                item.market_staff_flag = true;
                item.source_flag = false;
                item.sex_flag = false;
                item.birthday_flag = false;
                item.follow_staff_flag = false;
                item.custody_staff_flag = false;
                item.spare_area_code_flag = false;
                item.spare_mobile_flag = false;
                item.address_flag = false;
                item.school_flag = false;
                item.subject_flag = false;
                item.remark_flag = false;
                item.error_message_flag = false;
                item.error_background =
                  item.error_type === 1
                    ? "error_background_color"
                    : "success_background_color";
              });
              this.tableData = data.list;
              this.staffList = data.staff_list;
              this.marketStaffList = data.market_staff_list;
            } else {
              this.$message({
                type: "success",
                message: `成功导入${this.studentTotal}条数据`,
              });
              this.visibilityDialog = false;
              this.dialogVisible = false;
              this.$emit("change");
            }
          })
          .catch(() => {
            this.currentStep = 1;
          });
      }
    });
  }
}
